import { motion } from 'framer-motion'

import ContactUsHeroSection from '../../organisms/ContactUsHeroSection/ContactUsHeroSection'
import GetInTouchSection from '../../molecules/GetInTouchSection/GetInTouchSection'
import ContactUsFaq from '../../molecules/ContactUsFaq/ContactUsFaq'
import ContactInfoCards from '../../atoms/ContactInfoCards/ContactInfoCards'
import Footer from '../../organisms/Footer/Footer'
import colors from '../../theme/color'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'


const ContactUsPage = () => {
  const fadeUp = {
    initial: { opacity: 0, y: 80 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, margin: '-100px' },
    transition: { duration: 0.7, ease: 'easeIn' as const }
  }

  return (
    <main className="min-h-screen text-white" style={{ backgroundColor: colors.deepNavy }}>
      <ContactUsHeroSection />

      <motion.div {...fadeUp}>
        <GetInTouchSection />
      </motion.div>

      <motion.div {...fadeUp}>
        <div className="mb-14 md:mb-16">
          <ContactUsFaq />
        </div>
      </motion.div>

      <motion.div {...fadeUp}>
        <ContactInfoCards />
      </motion.div>
      <motion.div {...fadeUp}>
        <Testimonial className="mx-auto mb-20 max-w-[90%]" showHeader />
      </motion.div>

      <motion.div {...fadeUp}>
        <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
          <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
            <Message />
            <Questions />
          </div>
        </div>
      </motion.div>

        <Footer />
      
    </main>
  )
}

export default ContactUsPage
